import React, { useEffect, useState } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import emptyStateImage from 'assets/img/icn-empty-state.svg';
import BusinessLinesContainer from './newBusinessLines/container/BusinessLinesContainer';

import * as actions from '../action';
import * as c from '../constant';

function NewBusinessNaturesContent({
  handleAddModal,
  handleEdit,
  handleRemove,
  ordinanceRevisionId,
  newBusinessNaturesId,
  getSingleNewBusinessNatures,
  newBusinessNaturesInfo,

  getNewBusinessLinesList,
  newBusinessLinesList,
}) {
  const [formData, setFormData] = useState({
    keyword: '',
  });

  useEffect(() => {
    if (_.isEmpty(newBusinessNaturesId) && ordinanceRevisionId) return;
    getSingleNewBusinessNatures(newBusinessNaturesId);
    getNewBusinessLinesList(newBusinessNaturesId, {
      ordinance_revision_id: ordinanceRevisionId,
    });
  }, []);

  useEffect(() => {
    if (_.isEmpty(newBusinessNaturesId) && ordinanceRevisionId) return;
    getSingleNewBusinessNatures(newBusinessNaturesId);
    getNewBusinessLinesList(newBusinessNaturesId, {
      ordinance_revision_id: ordinanceRevisionId,
    });
    setFormData({
      keyword: '',
    });
  }, [newBusinessNaturesId, ordinanceRevisionId]);

  return (
    <div className="container-fluid card-section-content">
      <div className="card-body">
        <div className="row pt-4 pb-2 bg-white">
          <div className="col-12 d-flex">
            <button
              type="button"
              onClick={handleAddModal}
              className="btn btn-primary cms-bg-color-primary cms-outline-primary  btn-round font-weight-bold px-4 ml-auto   "
            >
              Add Business Nature &nbsp;&nbsp;
              <i className="fas fa-plus" />
            </button>
          </div>
        </div>
        {!_.isEmpty(newBusinessNaturesInfo) ? (
          <React.Fragment>
            <div className="row bg-white pb-3 mb-5">
              <div className="col-8">
                <h2 className="">
                  {_.get(newBusinessNaturesInfo, 'attributes.name')}
                </h2>
                <p className="label-secondary">
                  Code: &nbsp;
                  {_.get(newBusinessNaturesInfo, 'attributes.code') || '0'}
                </p>
              </div>
              <div className="col-4 d-flex">
                <div className="py-3 ml-auto">
                  <button
                    type="button"
                    className="btn-blank"
                    onClick={handleEdit(newBusinessNaturesInfo)}
                  >
                    <i className="far fa-edit icon-edit" />
                  </button>
                  <button
                    type="button"
                    className="btn-blank"
                    onClick={handleRemove(newBusinessNaturesInfo)}
                  >
                    <i className="far fa-trash-alt icon-delete" />
                  </button>
                </div>
              </div>
            </div>
            <div className="col-12">
              <div className="form-wrapper">
                <div>
                  <BusinessLinesContainer
                    ordinanceRevisionId={ordinanceRevisionId}
                    newBusinessNaturesId={newBusinessNaturesId}
                    newBusinessLinesList={newBusinessLinesList}
                    formData={formData}
                    setFormData={setFormData}
                  />
                </div>
              </div>
            </div>
          </React.Fragment>
        ) : (
          <div className="d-flex align-items-center justitfy-content-center h-100">
            <div className="text-center mx-auto py-4">
              <img
                src={emptyStateImage}
                className="img-responsive image-wrapper mb-4 mt-3"
                alt="Empty State"
              />
              <p className="emp-title mb-0"> No Item Found </p>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

NewBusinessNaturesContent.propTypes = {
  handleAddModal: PropTypes.instanceOf(Function).isRequired,
  handleEdit: PropTypes.instanceOf(Function).isRequired,
  handleRemove: PropTypes.instanceOf(Function).isRequired,

  getSingleNewBusinessNatures: PropTypes.instanceOf(Function).isRequired,
  newBusinessNaturesInfo: PropTypes.instanceOf(Object).isRequired,
  newBusinessNaturesId: PropTypes.string.isRequired,

  getNewBusinessLinesList: PropTypes.instanceOf(Function).isRequired,
  newBusinessLinesList: PropTypes.instanceOf(Array).isRequired,

  ordinanceRevisionId: PropTypes.number.isRequired,
};

const mapStateToProps = ({ api }, { match }) => ({
  newBusinessNaturesInfo:
    _.get(api, `${c.GET_SINGLE_NEW_BUSINESS_NATURES}.item`) || {},
  newBusinessNaturesId: _.get(match, 'params.newBusinessNaturesId') || '',

  newBusinessLinesList: _.get(api, `${c.GET_NEW_BUSINESS_LINES}.list`) || [],
});

const enhance = _.flowRight([withRouter, connect(mapStateToProps, actions)]);

export default enhance(NewBusinessNaturesContent);
